import { ResponseMeta } from './Response'

export type Pagination = {
  page?: number
  perPage?: number
  total?: number
  meta?: ResponseMeta
}

export const defaultPagination: Pagination = {
  page: 1,
  perPage: 30,
  total: 0,
}
